import React from "react";
import Card from "../../components/page/Card";
import Timeline from "../../components/timeline/Timeline";
import TimelineItem from "../../components/timeline/TimelineItem";
import CommonButton from "../../components/buttons/CommonButton";
import TimelineApiClient from "../../api/timeline";
import useApi from "../../hooks/useApi";
import { useParams } from "react-router-dom";
import { formataData } from "../../helpers/mesesHelper";
import NovoMigracaoModal from "./Migracao/NovoMigracaoModal";
import DadosEmpresaMigracaoModal from "./Migracao/DadosEmpresaMigracaoModal";
import LocalidadeApiClient from "../../api/localidade";
import CommonsApiClient from "../../api/commons";
import CertificadoMigracaoModal from "./Migracao/CertificadoMigracaoModal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import Validation from "../../helpers/Validation";
import Format from "../../helpers/Format";
import ErrorSwal from "../../components/Swal/errorSwal";
import SocioMigracaoModal from "./Migracao/SocioMigracaoModal";
import useTipos from "../../hooks/common/useTipos";
import ConclusaoMigracaoModal from "./Migracao/ConclusaoMigracaoModal";
import { AppContext } from "../../contexts/AppContext";
import RelatorioMigracaoModal from "./Migracao/RelatorioMigracaoModal";

function TimelineMigracao() {
  const [data, setData] = React.useState([]);
  const [novoProcessoModal, setNovoProcessoModal] = React.useState(false);
  const [dadosEmpresaMigracaoModal, setDadosEmpresaMigracaoModal] =
    React.useState(false);
  const [certificadoMigracaoModal, setCertificadoMigracaoModal] =
    React.useState(false);
  const [socioMigracaoModal, setSocioMigracaoModal] = React.useState(false);
  const [relatorioMigracaoModal, setRelatorioMigracaoModal] =
    React.useState(false);
  const [conclusaoMigracaoModal, setConclusaoMigracaoModal] =
    React.useState(false);
  const [values, setValues] = React.useState({});
  const [tabAtual, setTabAtual] = React.useState(0);
  const [estados, setEstados] = React.useState({});
  const [municipios, setMunicipios] = React.useState({});
  const [prevMunicipio, setPrevMunicipio] = React.useState("");
  const { uid } = useParams();
  const tiposEstadoCivil = useTipos("tipos_estado_civil");
  const tiposRegimeBens = useTipos("regime_bens");
  const { baseUrl, session } = React.useContext(AppContext);

  const getMunicipiosCb = React.useCallback(() => {
    return LocalidadeApiClient.listMunicipios(values.estadoId);
  }, [values.estadoId]);

  const { request: getProcesso, data: procesoResponse } = useApi(
    TimelineApiClient.getProcessoMigracao
  );
  const atualizarEtapaMigracaoApi = useApi(
    TimelineApiClient.atualizarEtapaMigracao
  );
  const finalizarMigracaoApi = useApi(
    TimelineApiClient.finalizarProcessoMigracao
  );
  const verificarSocioMigracaoApi = useApi(
    TimelineApiClient.verificarSocioMigracao
  );
  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const documentoRouteApi = useApi(CommonsApiClient.documentoRoute);
  const { request: getMunicipios, data: municipiosResponse } =
    useApi(getMunicipiosCb);
  const { request: getEstados } = useApi(LocalidadeApiClient.listEstados);

  React.useLayoutEffect(() => {
    if (!uid && !session?.empresa_uid) return;
    getProcesso(uid || session?.empresa_uid);
  }, [getProcesso, session?.empresa_uid, uid]);

  const setPageTitle = React.useCallback((razao_social) => {
    const titleElement = document.querySelector(".page-title h4");
    if (titleElement) {
      const helpIcon = titleElement.querySelector("svg");
      const textNode = titleElement.childNodes[0];
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = `Processos de Migração - ${razao_social}`;
      } else {
        const newTextNode = document.createTextNode(
          `Processos de Migração - ${razao_social}`
        );
        titleElement.insertBefore(newTextNode, helpIcon);
      }
    }
  }, []);

  const togRelatorioMigracaoModal = React.useCallback(() => {
    setRelatorioMigracaoModal(true);
  }, []);

  const addToggleButton = React.useCallback(() => {
    const pageTitle = document.querySelector(".page-title");
    if (!pageTitle) return;

    const existingButton = pageTitle.querySelector(".toggle-modal-button");
    if (existingButton) {
      existingButton.remove();
    }

    const button = document.createElement("button");
    button.className = "btn btn-primary toggle-modal-button";
    const icon = document.createElement("i");
    icon.className = "mdi mdi-file-search-outline d-block font-size-18";
    button.appendChild(icon);
    button.addEventListener("click", togRelatorioMigracaoModal);

    pageTitle.appendChild(button);

    return () => {
      button.removeEventListener("click", togRelatorioMigracaoModal);
      button.remove();
    };
  }, [togRelatorioMigracaoModal]);

  React.useEffect(() => {
    if (!procesoResponse) return;
    setData(procesoResponse);
    setPageTitle(procesoResponse?.razao_social);
    if (session?.empresa_uid && !uid) addToggleButton();
  }, [
    addToggleButton,
    procesoResponse,
    session?.empresa_uid,
    setPageTitle,
    uid,
  ]);

  //Busca estados ao renderizar tela
  React.useEffect(() => {
    const buscarEstados = async () => {
      var estadosResponse = await getEstados();
      if (!estadosResponse) return;
      setEstados(() => ({
        ...estadosResponse,
      }));
    };
    buscarEstados();
  }, [getEstados, setEstados]);

  //Define estado municipios ao receber municipios
  React.useEffect(() => {
    if (!municipiosResponse) return;
    setMunicipios(() => ({ ...municipiosResponse }));
    if (prevMunicipio && !values?.cidade_nascimento)
      setValues((prevValues) => ({
        ...prevValues,
        cidade_nascimento: prevMunicipio,
      }));
  }, [
    municipiosResponse,
    prevMunicipio,
    setMunicipios,
    values?.cidade_nascimento,
    values.estadoId,
  ]);

  //Busca municipios ao alterar valor do campo estado
  React.useEffect(() => {
    if (!values?.estadoId) return;
    getMunicipios();
  }, [getMunicipios, prevMunicipio, values?.estadoId]);

  const numeroSocios = React.useMemo(
    () => data?.etapas?.["0"]?.dados?.numero_socios || 0,
    [data?.etapas]
  );

  const startIndex = React.useMemo(() => {
    const etapas = data?.etapas || {};
    const keys = Object.keys(etapas);
    const lastCompletedIndex = keys.reduce((maxIndex, key, index) => {
      if (etapas[key].status === "CONCLUIDA") {
        return Math.max(maxIndex, index);
      }
      return maxIndex;
    }, -1);

    if (etapas["1"]?.status === "CONCLUIDA") {
      return lastCompletedIndex + numeroSocios - 1;
    }
    return lastCompletedIndex + 1;
  }, [data?.etapas, numeroSocios]);

  const getTimelineItemProps = (
    etapa,
    title,
    buttonContent,
    dependsOnEtapa,
    finished = null,
    socio = null,
    socioFinished = false
  ) => {
    const isConcluida = data?.etapas?.[etapa]?.status === "CONCLUIDA";
    const isDependenciaConcluida = dependsOnEtapa
      ? data?.etapas?.[dependsOnEtapa]?.status === "CONCLUIDA"
      : true;

    return {
      header: {
        text: socio
          ? `Sócio - ${socio}`
          : isConcluida
            ? `Concluída - ${formataData(data?.etapas?.[etapa]?.data)}`
            : isDependenciaConcluida
              ? "Em andamento"
              : "-",
        color: isConcluida || socioFinished ? "success" : "primary",
      },
      title,
      icon: {
        icon:
          isConcluida || socioFinished
            ? "bx bx-check-circle"
            : "bx bx-down-arrow-circle",
        color: isConcluida || socioFinished ? "success" : "primary",
      },
      button: isDependenciaConcluida ? (
        isConcluida && finished ? (
          finished
        ) : (
          buttonContent
        )
      ) : (
        <div className="mt-3 px-3">
          <p className="text-muted">
            Para realizar essa etapa é necessário concluir as etapas anteriores
          </p>
        </div>
      ),
    };
  };

  const togNovoProcessoModal = () => {
    const dados = data?.etapas?.["0"]?.dados || {};
    setValues({
      ...dados,
      cpf_empresa: dados?.cnpj || "",
      apelido_empresa: dados?.razao_social || "",
      celular_empresa: dados?.celular || "",
    });
    setNovoProcessoModal(true);
  };

  const togDadosEmpresaMigracaoModal = () => {
    const dados = data?.etapas?.["2"]?.dados || {};
    setValues({
      ...(dados?.endereco || {}),
      cartao_cnpj: dados?.cartao_cnpj?.caminho || "",
      contrato_social: dados?.contrato_social?.caminho || "",
      cartao_cnpj_ext: dados?.cartao_cnpj?.ext || "",
      contrato_social_ext: dados?.contrato_social?.ext || "",
      codigo_cidade: dados?.endereco?.cod_cidade || "",
    });
    setTabAtual(0);
    setDadosEmpresaMigracaoModal(true);
  };

  const togCertificadoMigracaoModal = () => {
    setCertificadoMigracaoModal(true);
  };

  const togSocioMigracaoModal = (index) => {
    const { dados_pessoais, endereco, identidade, titulo_eleitor } =
      data?.etapas?.["1"]?.dados?.[index] || {};

    const estadosArray = Array.isArray(estados)
      ? estados
      : Object.values(estados);
    const estado = estadosArray.find(
      (estado) => estado.sigla === dados_pessoais?.uf_nascimento
    );

    setValues({
      ...(dados_pessoais || {}),
      ...(endereco || {}),
      identidade_numero: dados_pessoais?.identidade || "",
      identidade: identidade?.caminho || "",
      titulo_eleitor: titulo_eleitor?.caminho || "",
      identidade_ext: identidade?.ext || "",
      titulo_eleitor_ext: titulo_eleitor?.ext || "",
      estadoId: estado?.id || "",
      id: index,
      adm_responsavel: dados_pessoais?.adm_responsavel === "1" ? true : false,
      adm_responsavel_original: dados_pessoais?.adm_responsavel,
    });
    setPrevMunicipio(dados_pessoais?.cidade_nascimento);
    setTabAtual(0);
    setSocioMigracaoModal(true);
  };

  const togConclusaoMigracaoModal = () => {
    setValues({
      razao_social: data?.razao_social,
      cnpj: data?.etapas?.["0"]?.dados?.cnpj,
    });
    setConclusaoMigracaoModal(true);
  };

  const finishProcess = () => {
    OptionsSwal({
      icon: "question",
      title: "Tem certeza que deseja finalizar o processo de migração?",
    }).then((result) => {
      if (result.isConfirmed) {
        togConclusaoMigracaoModal();
      } else {
        CommonSwal({
          icon: "success",
          title: "Verifique as etapas sem pressa.",
        });
      }
    });
  };

  const timelineItems = [
    {
      etapa: "0",
      title: "Contrato",
      buttonContent: (
        <CommonButton color="info" onClick={togNovoProcessoModal}>
          <i className="mdi mdi-file-document-edit d-block font-size-18"></i>
        </CommonButton>
      ),
      dependsOnEtapa: null,
    },
    ...Array.from({ length: numeroSocios }, (_, index) => ({
      etapa: "1",
      title: `Cadastro do ${index + 1}° sócio`,
      buttonContent: (
        <CommonButton
          color="info"
          onClick={() => {
            togSocioMigracaoModal(index);
          }}
        >
          <i className="mdi mdi-account-edit d-block font-size-18"></i>
        </CommonButton>
      ),
      dependsOnEtapa: "0",
      socio: data?.etapas?.["1"]?.dados?.[index]?.dados_pessoais?.nome || null,
      socioFinished:
        data?.etapas?.["1"]?.dados?.[index]?.status === "CONCLUIDO" || false,
    })),
    {
      etapa: "2",
      title: "Dados da empresa",
      buttonContent: (
        <CommonButton color="info" onClick={togDadosEmpresaMigracaoModal}>
          <i className="mdi mdi-file-document-edit d-block font-size-18"></i>
        </CommonButton>
      ),
      dependsOnEtapa: "1",
    },
    {
      etapa: "3",
      title: "Certificado digital e-CNPJ A1",
      buttonContent: (
        <CommonButton color="info" onClick={togCertificadoMigracaoModal}>
          <i className="mdi mdi-shield-key d-block font-size-18"></i>
        </CommonButton>
      ),
      dependsOnEtapa: "2",
    },
    {
      etapa: "4",
      title: "Processo de migração finalizado!",
      buttonContent: (
        <CommonButton color="info" onClick={finishProcess}>
          <i className="mdi mdi-clipboard-check-multiple d-block font-size-18"></i>
        </CommonButton>
      ),
      finished: (
        <div className="mt-3 px-3">
          <p className="text-muted">
            Agora é só aguardar que logo você receberá o acesso à nossa
            plataforma!
          </p>
        </div>
      ),
      dependsOnEtapa: "3",
    },
  ];

  const downloadDocumento = async (caminho, ext) => {
    const response = await documentoRouteApi.request(caminho, {
      ext: ext,
      type: "download",
    });
    if (!response) return;
    const blob = new Blob([response]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${caminho}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const atualizarEtapaUm = async () => {
    const formData = new FormData();
    formData.append("link_contrato", values?.link_contrato);
    formData.append("data_assinatura", values?.data_assinatura);
    formData.append("mensalidade", values?.mensalidade);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cpf_empresa));
    formData.append("razao_social", values?.apelido_empresa);
    formData.append("email_empresa", values?.email_empresa);
    formData.append("celular_empresa", values?.celular_empresa);
    formData.append("inicio_prestacao", values?.inicio_prestacao);
    formData.append("numero_socios", values?.numero_socios);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (Validation.validarEmail(values?.email_empresa))
      return ErrorSwal({
        text: "Favor inserir um e-mail válido.",
      });

    const response = await atualizarEtapaMigracaoApi.request(
      uid || session?.empresa_uid,
      1,
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Etapa atualizada com sucesso!", icon: "success" });
    setNovoProcessoModal(false);
    getProcesso(uid || session?.empresa_uid);
  };

  const atualizarEtapaDois = async () => {
    const atualizarEtapa = async () => {
      let completo = true;
      const formData = new FormData();
      formData.append("id", values?.id.toString() || "");
      formData.append("nome", values?.nome || "");
      formData.append("cpf", values?.cpf || "");
      formData.append("identidade_numero", values?.identidade_numero || "");
      formData.append("expedidor_rg", values?.expedidor_rg || "");
      formData.append("profissao", values?.profissao || "");
      formData.append("data_nascimento", values?.data_nascimento || "");
      formData.append("uf_nascimento", values?.uf_nascimento || "");
      formData.append("cidade_nascimento", values?.cidade_nascimento || "");
      formData.append("email", values?.email || "");
      formData.append("celular", values?.celular || "");
      formData.append("estado_civil", values?.estado_civil || "");
      formData.append("adm_responsavel", values?.adm_responsavel ? "1" : "0");
      if (parseInt(values?.estado_civil) === 2)
        formData.append("regime_bens", values?.regime_bens || "");

      formData.append("cep", values?.cep || "");
      formData.append("logradouro", values?.logradouro || "");
      formData.append("numero", values?.numero || "");
      formData.append("bairro", values?.bairro || "");
      formData.append("cidade", values?.cidade || "");
      formData.append("uf", values?.uf || "");

      formData.append("identidade", values?.identidade || "");
      formData.append("titulo_eleitor", values?.titulo_eleitor || "");

      if (Validation.verificarForm(formData)) completo = false;

      if (
        data?.etapas?.["1"]?.dados?.[values?.id]?.status === "CONCLUIDO" &&
        values?.cep &&
        !values?.codigo_cidade
      )
        return ErrorSwal({
          text: "Favor inserir um CEP válido.",
        });

      if (
        data?.etapas?.["1"]?.dados?.[values?.id]?.status === "CONCLUIDO" &&
        Validation.validarEmail(values?.email)
      )
        return ErrorSwal({
          text: "Favor inserir um e-mail válido.",
        });

      if (
        data?.etapas?.["1"]?.dados?.[values?.id]?.status === "CONCLUIDO" &&
        completo === false
      )
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

      if (parseInt(values?.estado_civil) !== 2)
        formData.append("regime_bens", values?.regime_bens || "");
      formData.append("pis", values?.pis || "");
      formData.append("compl", values?.compl || "");

      const response = await atualizarEtapaMigracaoApi.request(
        uid || session?.empresa_uid,
        2,
        formData
      );
      if (!response) return;
      completo
        ? CommonSwal({
            title: "Etapa atualizada com sucesso!",
            icon: "success",
          })
        : CommonSwal({
            title:
              "Ainda faltam dados obrigatórios para o cadastro deste sócio!",
            icon: "info",
          });
      setSocioMigracaoModal(false);
      getProcesso(uid || session?.empresa_uid);
    };

    if (
      (values?.adm_responsavel_original === "0" ||
        !values?.adm_responsavel_original) &&
      values?.adm_responsavel === true
    ) {
      const formDataVerificar = new FormData();
      formDataVerificar.append("id", values?.id.toString() || "");

      const responseVerificar = await verificarSocioMigracaoApi.request(
        uid || session?.empresa_uid,
        formDataVerificar
      );
      if (!responseVerificar) return;
      if (responseVerificar?.icon)
        OptionsSwal({
          icon: responseVerificar?.icon,
          title: responseVerificar?.title,
          text: responseVerificar?.text,
        }).then(async (result) => {
          if (result.isConfirmed) {
            await atualizarEtapa();
          }
        });
      else {
        await atualizarEtapa();
      }
    } else {
      await atualizarEtapa();
    }
  };

  const atualizarEtapaTres = async () => {
    const formData = new FormData();

    formData.append("cep", values?.cep);
    formData.append("logradouro", values?.logradouro);
    formData.append("numero", values?.numero);
    formData.append("bairro", values?.bairro);
    formData.append("cidade", values?.cidade);
    formData.append("uf", values?.uf);
    formData.append("cod_cidade", values?.codigo_cidade);

    formData.append("cartao_cnpj", values?.cartao_cnpj);
    formData.append("contrato_social", values?.contrato_social);

    if (values?.cep && !values?.codigo_cidade)
      return ErrorSwal({
        text: "Favor inserir um CEP válido.",
      });

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    formData.append("compl", values?.compl || "");

    const response = await atualizarEtapaMigracaoApi.request(
      uid || session?.empresa_uid,
      3,
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Etapa atualizada com sucesso!", icon: "success" });
    setDadosEmpresaMigracaoModal(false);
    getProcesso(uid || session?.empresa_uid);
  };

  const atualizarEtapaQuatro = async () => {
    const response = await atualizarEtapaMigracaoApi.request(
      uid || session?.empresa_uid,
      4,
      {}
    );
    if (!response) return;
    CommonSwal({ title: "Etapa atualizada com sucesso!", icon: "success" });
    setCertificadoMigracaoModal(false);
    getProcesso(uid || session?.empresa_uid);
  };

  const finalizarMigracao = async () => {
    const formData = new FormData();

    let empresa = values?.razao_social.replace(/[^a-zA-Z0-9 ]/g, "");
    empresa = empresa.replace(/[ ]/g, "_");

    formData.append("empresa", empresa);
    formData.append("nome_empresa", values?.razao_social);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cnpj));
    formData.append("cnpj_empresa", Format.formatCNPJCPF(values?.cnpj));
    formData.append("contabilidade", "Orangiuz");

    const response = await finalizarMigracaoApi.request(
      uid || session?.empresa_uid,
      formData
    );
    if (!response) return;
    setCertificadoMigracaoModal(false);
    CommonSwal({
      title: "Migração finalizada com sucesso!",
      icon: "success",
    }).then((result) => {
      if (result.isConfirmed || result.isDismissed || result.isDenied) {
        window.location.href = baseUrl + `timeline/EmpresasMigracao/`;
      }
    });
  };

  return (
    <Card>
      <Timeline key={Date.now()} startIndex={startIndex}>
        {timelineItems.map((item, index) => (
          <TimelineItem
            key={index}
            {...getTimelineItemProps(
              item.etapa,
              item.title,
              item.buttonContent,
              item.dependsOnEtapa,
              item.finished,
              item.socio,
              item.socioFinished
            )}
          />
        ))}
      </Timeline>
      <NovoMigracaoModal
        criarNovoProcesso={atualizarEtapaUm}
        modalHook={{ novoProcessoModal, setNovoProcessoModal }}
        valuesHook={{ values, setValues }}
        editar={true}
      />
      <DadosEmpresaMigracaoModal
        cepApi={{ getCep, cepResponse }}
        downloadDocumento={downloadDocumento}
        modalHook={{ dadosEmpresaMigracaoModal, setDadosEmpresaMigracaoModal }}
        salvarProcesso={atualizarEtapaTres}
        tabHook={{ tabAtual, setTabAtual }}
        valuesHook={{ values, setValues }}
      />
      <CertificadoMigracaoModal
        concluirEtapa={atualizarEtapaQuatro}
        modalHook={{ certificadoMigracaoModal, setCertificadoMigracaoModal }}
      />
      <SocioMigracaoModal
        cepApi={{ getCep, cepResponse }}
        downloadDocumento={downloadDocumento}
        modalHook={{ socioMigracaoModal, setSocioMigracaoModal }}
        salvarProcesso={atualizarEtapaDois}
        tabHook={{ tabAtual, setTabAtual }}
        valuesHook={{ values, setValues }}
        estados={estados}
        municipios={municipios}
        tiposEstadoCivil={tiposEstadoCivil}
        tiposRegimeBens={tiposRegimeBens}
      />
      <ConclusaoMigracaoModal
        finalizarMigracao={finalizarMigracao}
        modalHook={{ conclusaoMigracaoModal, setConclusaoMigracaoModal }}
        valuesHook={{ values, setValues }}
      />
      <RelatorioMigracaoModal
        modalHook={{ relatorioMigracaoModal, setRelatorioMigracaoModal }}
        etapas={data?.etapas || {}}
        tiposEstadoCivil={tiposEstadoCivil}
        tiposRegimeBens={tiposRegimeBens}
      />
    </Card>
  );
}

export default TimelineMigracao;
